import React from "react";

const Icon = () => {
  return (
    <svg
      width="16"
      height="16"
      viewBox="0 0 16 16"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      style={{ display: "inline-block" }}
    >
      <path
        d="M10 16H11L16 11L11 6H10V10H4V1H2V12H10V16Z"
        fill="#333333"   /* change color if needed */
      />
    </svg>
  );
};

export default Icon;